import type { APIError } from "@/lib/api";

/** Mensaje legible a partir de errores DRF (detail / campos). */
export function formatRubrosApiError(error: unknown, fallback: string): string {
  const e = error as APIError;
  let msg = e?.message && String(e.message).trim() ? String(e.message) : fallback;
  const d = e?.details;

  if (typeof d === "string" && d.trim()) {
    return `${msg}: ${d}`;
  }

  if (d && typeof d === "object" && !Array.isArray(d)) {
    const parts = Object.entries(d as Record<string, unknown>)
      .map(([k, v]) => {
        if (Array.isArray(v)) return `${k}: ${v.join(", ")}`;
        if (v && typeof v === "object") return `${k}: ${JSON.stringify(v)}`;
        return `${k}: ${String(v)}`;
      })
      .filter(Boolean);
    if (parts.length) msg = `${msg} — ${parts.join("; ")}`;
  }

  return msg;
}
